<div class="p-5 w-full max-w-lg">

  <!-- Header -->
  <div class="flex items-start gap-3 mb-4">
    <img
      *ngIf="data.item.referencePhotoDownloadUrl"
      [src]="data.item.referencePhotoDownloadUrl"
      (click)="openImage(data.item.referencePhotoDownloadUrl)"
      matTooltip="View full size"
      class="w-12 h-12 object-cover rounded border border-gray-200 flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity"
      alt="Reference photo" />
    <div>
      <div class="text-sm font-semibold text-gray-800 leading-snug">{{ data.item.name }}</div>
      <span class="text-xs text-gray-400 uppercase tracking-wide">{{ data.findingType }}</span>
    </div>
  </div>

  <form [formGroup]="form" class="space-y-4">

    <!-- Notes -->
    <div>
      <label class="block text-xs text-gray-500 mb-1">Notes</label>
      <textarea
        formControlName="notes"
        rows="3"
        [readonly]="data.viewOnly"
        class="w-full border border-gray-300 rounded px-3 py-2 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-orange-400 resize-y"
        [class.bg-gray-50]="data.viewOnly">
      </textarea>
    </div>

    <!-- Photos -->
    <div>
      <label class="block text-sm font-medium text-gray-600 mb-2">
        Photos ({{ photos.length }}/{{ MAX_PHOTOS }})
      </label>

      <label
        *ngIf="!data.viewOnly && photos.length < MAX_PHOTOS"
        class="inline-flex items-center gap-2 cursor-pointer px-3 py-1.5 text-sm border border-gray-300 rounded hover:bg-gray-50"
        [class.opacity-50]="uploadingPhoto">
        <span>{{ uploadingPhoto ? 'Uploading...' : '+ Add Photo' }}</span>
        <input
          type="file"
          accept="image/*"
          class="hidden"
          [disabled]="uploadingPhoto"
          (change)="onPhotoSelected($event)" />
      </label>

      <div *ngIf="photos.length > 0" class="flex flex-wrap gap-2 mt-3">
        <div
          *ngFor="let photo of photos; let i = index"
          class="relative w-20 h-20 rounded overflow-hidden border border-gray-200">
          <img [src]="photo.downloadUrl"
               (click)="openImage(photo.downloadUrl)"
               matTooltip="View full size"
               class="w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity"
               alt="Finding photo" />
          <button
            *ngIf="!data.viewOnly"
            type="button"
            (click)="removePhoto(i)"
            class="absolute top-1 right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600">
            ×
          </button>
        </div>
      </div>
    </div>

    <!-- Voice Note playback (read-only — recorded on mobile) -->
    <div *ngIf="data.voiceNoteUrl" class="mt-4">
      <label class="block text-sm font-medium text-gray-600 mb-2">Voice Note</label>
      <audio
        controls
        [src]="data.voiceNoteUrl"
        class="w-full rounded"
        preload="metadata">
        Your browser does not support audio playback.
      </audio>
    </div>

  </form>

  <!-- Actions -->
  <div class="flex justify-end gap-3 mt-5">
    <button mat-stroked-button (click)="cancel()">
      {{ data.viewOnly ? 'Close' : 'Cancel' }}
    </button>
    <button
      *ngIf="!data.viewOnly"
      mat-raised-button
      color="primary"
      [disabled]="uploadingPhoto"
      (click)="confirm()">
      Confirm
    </button>
  </div>

</div>
